import { html } from 'lit';
import type { SlotTemplateResult } from '../types.js';
import type { OneUxCardElement } from '../OneUxCardElement.js';
import { toSlotTemplateResult } from '../toSlotTemplateResult.js';
export function CardMiddleFragment(this: OneUxCardElement, results: SlotTemplateResult[]): SlotTemplateResult {
  const hasSlot = results.some(({
    hasSlot
  }) => hasSlot);
  const template = html`<div ?hidden=${!hasSlot} class="remaining-space rows">${results}</div>`;
  return toSlotTemplateResult(template, hasSlot);
}